/** @format */

import { Button, Modal } from "react-bootstrap";

const SuccessModal = ({ show, handleClose, selectedJob }) => (
  <Modal show={show} onHide={handleClose} centered>
    <Modal.Header closeButton>
      <Modal.Title>Application Successful!</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        Your application for {selectedJob?.title} has been submitted
        successfully!
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleClose}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
);

export default SuccessModal;
